import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleBasedRoute = ({ children, allowedRoles = [], redirectTo = '/login', fallbackRoute = null }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <div className="spinner"></div>
            </div>
        );
    }

    // If not authenticated, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // If user role is not in allowed roles
    if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
        // If fallback route is provided, use it, otherwise use default redirect based on role
        if (fallbackRoute) {
            return <Navigate to={fallbackRoute} replace />;
        }

        // Default redirects based on user role
        if (user.role === 'admin' || user.role === 'doctor') {
            return <Navigate to="/admin" replace />;
        } else if (user.role === 'patient') {
            return <Navigate to="/dashboard" replace />;
        }

        // Fallback to login if role is unknown
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default RoleBasedRoute;